import type { Platform } from "../api/types";
import type { DeviceBridge } from "./DeviceBridge";
import { createWebBridge } from "./webBridge";

// A native shell injects its own bridge on `window.__GOCITYSCREENS_BRIDGE__` and sets
// `window.__GOCITYSCREENS_PLATFORM__` before the web bundle boots. Otherwise we fall
// back to the web/PWA bridge.

declare global {
  interface Window {
    __GOCITYSCREENS_BRIDGE__?: DeviceBridge;
    __GOCITYSCREENS_PLATFORM__?: Platform;
  }
}

function detectPlatform(): Platform {
  if (typeof window !== "undefined" && window.__GOCITYSCREENS_PLATFORM__) {
    return window.__GOCITYSCREENS_PLATFORM__;
  }
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  if (/Tizen/i.test(ua)) return "tizen";
  if (/Web0S|webOS/i.test(ua)) return "webos";
  if (/Android/i.test(ua)) return "android";
  return "web";
}

let bridgeSingleton: DeviceBridge | null = null;

export function getBridge(): DeviceBridge {
  if (bridgeSingleton) return bridgeSingleton;
  if (typeof window !== "undefined" && window.__GOCITYSCREENS_BRIDGE__) {
    bridgeSingleton = window.__GOCITYSCREENS_BRIDGE__;
  } else {
    bridgeSingleton = createWebBridge(detectPlatform());
  }
  return bridgeSingleton;
}

export type { DeviceBridge } from "./DeviceBridge";
